<template>
  <v-select
    :model-value="currentDomain"
    :items="domains"
    item-title="name"
    item-value="value"
    label="Domain"
    hide-details
    variant="outlined"
    density="compact"
    max-width="180"
    @update:model-value="updateDomain"
  />
</template>

<script lang="ts">
import { storeToRefs } from 'pinia'
import { defineComponent } from 'vue'

import { useDomainStore } from '@/stores/domain'

import type { Domain } from '@policyfly/protobuf/pfbingo'

export default defineComponent({
  name: 'DomainSelect',

  setup () {
    const domainStore = useDomainStore()
    const { domains, currentDomain } = storeToRefs(domainStore)

    function updateDomain (domain: Domain): void {
      domainStore.setCurrentDomain(domain)
    }

    return {
      domains,
      currentDomain,
      updateDomain,
    }
  },
})
</script>
